import { Component } from 'solid-js';
import {
  stopsContainLightColor,
  SWATCH_BORDER_CLASS,
} from '../color-swatch-border';
import { transparencyCheckerboardStyle } from './heatmap-css';

interface HeatmapPreviewBarProps {
  readonly stops: readonly { readonly color: string }[];
  readonly backgroundCss: string;
  readonly testId?: string;
}

export const HeatmapPreviewBar: Component<HeatmapPreviewBarProps> = (props) => {
  const borderClass = (): string =>
    stopsContainLightColor(props.stops) ? SWATCH_BORDER_CLASS : '';

  return (
    <div
      class={`relative h-4 w-full overflow-hidden rounded-md box-border ${borderClass()}`}
      data-testid={props.testId}
    >
      <div
        class="absolute inset-0"
        style={transparencyCheckerboardStyle()}
        aria-hidden="true"
      />
      <div
        class="absolute inset-0"
        style={{ background: props.backgroundCss }}
        aria-hidden="true"
      />
    </div>
  );
};
